export const visaIcon = {
  data: `<svg viewBox="0 0 50 32">
          <title>visa</title>
          <path
            fill="#fff"
            style="fill: var(--color1, #fff)"
            d="M50.375 32h-50.375v-32h50.375v32z"
          ></path>
          <path
            fill="#f7b600"
            style="fill: var(--color2, #f7b600)"
            d="M0.839 26.8h48.697v4.366h-48.697v-4.366z"
          ></path>
          <path
            fill="#1a1f71"
            style="fill: var(--color3, #1a1f71)"
            d="M0.839 5.205h48.697v-4.366h-48.697v4.366z"
          ></path>
          <path
            fill="#1a1f71"
            style="fill: var(--color3, #1a1f71)"
            d="M24.767 10.015l-2.567 12h-3.105l2.567-12h3.104zM37.828 17.764l1.634-4.507 0.94 4.507h-2.575zM41.294 22.016h2.871l-2.508-12h-2.648c-0.597 0-1.1 0.346-1.322 0.88l-4.659 11.121h3.26l0.647-1.792h3.982l0.376 1.792zM33.189 18.098c0.014-3.167-4.378-3.342-4.349-4.757 0.010-0.43 0.42-0.888 1.316-1.005 0.445-0.057 1.671-0.104 3.062 0.537l0.544-2.546c-0.747-0.27-1.708-0.53-2.904-0.53-3.069 0-5.228 1.63-5.246 3.967-0.020 1.728 1.542 2.691 2.717 3.266 1.211 0.588 1.617 0.966 1.611 1.491-0.008 0.805-0.966 1.161-1.857 1.175-1.562 0.024-2.467-0.422-3.189-0.758l-0.563 2.631c0.726 0.333 2.065 0.622 3.451 0.637 3.263 0 5.396-1.611 5.406-4.106zM20.331 10.015l-5.030 12h-3.281l-2.476-9.577c-0.15-0.589-0.281-0.805-0.737-1.054-0.747-0.406-1.979-0.785-3.063-1.021l0.073-0.348h5.283c0.673 0 1.278 0.448 1.432 1.223l1.308 6.945 3.23-8.168h3.262z"
          ></path>
        </svg>`,
  name: 'visa',
};
